import React from 'react';
import './Spinner.css'; // Make sure to import the CSS file

function Spinner() {
  return (
    <div className="spinner-container">
      <i className="icon-PLM-new-logo" />
    </div>
  );
}

export default Spinner;
